document.addEventListener("DOMContentLoaded", function () {
    const shareButton = document.getElementById("share-link-button");

    if (shareButton) {
        const originalContent = shareButton.innerHTML;

        shareButton.addEventListener("click", function () {
            const url = this.getAttribute("data-url");

            navigator.clipboard.writeText(url).then(
                function () {
                    // Success feedback
                    shareButton.textContent = "Copied!";
                    setTimeout(function () {
                        shareButton.innerHTML = originalContent;
                    }, 2000);
                },
                function (err) {
                    console.error("Could not copy text: ", err);
                }
            );
        });
    }
});
